<template>
    <div style="margin-bottom: 1rem;">
      <h3 class="title ">Smart Roadshow Admintool</h3>
    </div>
</template>

<script>
    export default {
        name: "headbar"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Headbar.vue